/** @format */
import {PointName} from 'components/charts/multiline-chart/model/common';

import {ComplexValue, GraphComplexValuesList} from '../../models/common';
import {ALL_COMPLEX_VALUES} from '../../constants/allChartIds';

const makeZeroValues = (): ComplexValue => {
  const obj = {} as ComplexValue;
  ALL_COMPLEX_VALUES.forEach(key => {
    obj[key] = 0;
  });
  return obj;
};

const aggregateGraphComplexValues = (
  complexValuesList: GraphComplexValuesList,
  rechartsDates: string[],
): GraphComplexValuesList => {
  if (rechartsDates.length === 0) {
    return {};
  }

  const discreteSet = new Set(rechartsDates);
  const allPoints = Object.keys(complexValuesList) as PointName[];

  // Инициализируем аккумулятор
  let acc = makeZeroValues();

  const result: GraphComplexValuesList = {};

  for (let i = 0; i < allPoints.length; i++) {
    const pointName = allPoints[i];
    const entry = complexValuesList[pointName];
    const date = entry.date;

    if (!entry) {
      result[pointName] = {date, values: makeZeroValues()};
      continue;
    }

    const statValues = entry.values;

    ALL_COMPLEX_VALUES.forEach(key => {
      acc[key] += statValues[key];
    });

    const isDiscrete = discreteSet.has(entry.date);

    if (isDiscrete) {
      result[pointName] = {
        date,
        values: {...acc},
      };

      acc = makeZeroValues();
    } else {
      result[pointName] = {
        date,
        values: makeZeroValues(),
      };
    }
  }

  return result;
};

export {aggregateGraphComplexValues};
